export const APP_LOGO_URL = "/RAILWAY_LOGO.png";
export const SIDEBAR_LOGO_URL = "/RAILWAY_LOGO.png";
export const APP_LOGO_ALT = "Western Railway";
export const APP_BRAND_TITLE = "Western Railway | Waterlogging";
